import * as React from 'react';
import DetailsSection from 'nomst/Components/SharedJobCollab/detailsSection';
import SkillsCard from 'nomst/Components/JobDetails/skillsCard';
import { mxStrings } from 'utils/JobCollabStrings';

export interface SkillsAndCertsSectionProps {
    skills: Answer[];
    certifications: Answer[];
}

class SkillsAndCertsSection extends React.PureComponent<SkillsAndCertsSectionProps, {}> {

    render(): React.ReactNode {
        const { skills, certifications } = this.props;

        const hasSkills = !!skills?.length;
        const hasCerts = !!certifications?.length;
        const showHeader = hasCerts || hasSkills;

        return (
            <DetailsSection
                title={showHeader ? mxStrings.skillsAndCerts : null}
                className="skills-and-certs"
            >
                <SkillsCard skills={skills} title={mxStrings.skills}/>
                <SkillsCard skills={certifications} title={mxStrings.certs}/>
            </DetailsSection>
        );
    }
}

export { SkillsAndCertsSection };
export default SkillsAndCertsSection;